import {
    Back2Icon,
    BackIcon, Close2Icon, Close3Icon, DateIcon,
    DateLabel,
    DatePickerContainer,
    DatePickerContainerBg,
    DatePickerContainerContent,
    DatePickerContainerTitle, DateRow, DateSelect, MInput, MInputContainer, MModal, MModalHead
} from "./styles";
import { useApp } from "../../contexts";
import { ContainerCenter, ContainerRow, DesktopContainer, MobileContainer } from "../Container";
import { FormButton, FormButtonCancel } from "../Form";
import FormButton2 from "../FormCustom2/Button";
import moment from "moment";
import { useState } from "react";

export const DatePickerView = (props) => {
    const { T } = useApp();
    const [fromDate, setFromDate] = useState(moment(props.fromDate));
    const [toDate, setToDate] = useState(moment(props.toDate));
    const [visible, setVisible] = useState();

    const onChange = (date, field) => {
        if (field === 'fromDate') {
            setFromDate(date);
        }
        if (field === 'toDate') {
            setToDate(date);
        }
    }

    const onSubmit = () => {
        props.onChange({
            fromDate, toDate
        })
    }

    return (
        <DatePickerContainer>
            <DatePickerContainerBg />
            <DatePickerContainerContent>
                <DatePickerContainerTitle>
                    <MobileContainer ><span onClick={props?.onCancel}><BackIcon /></span></MobileContainer>
                    {T("Select Time Range")}
                </DatePickerContainerTitle>
                <DesktopContainer className="mb-[56px]">
                    <DateRow>
                        <DateLabel>{T("From")}</DateLabel>
                        <ContainerRow style={{ width: 34 }} />
                        <DateLabel>{T("To")}</DateLabel>
                    </DateRow>
                    <DateRow>
                        <DateSelect
                            value={fromDate}
                            onSelect={(event) => onChange(event, 'fromDate')}
                            minDate={fromDate} maxDate={toDate} mode={'min'}
                        />
                        <ContainerRow style={{ width: 34 }} />
                        <DateSelect minDate={fromDate} maxDate={toDate} value={toDate} mode={'max'}
                            onSelect={(event) => onChange(event, 'toDate')} />
                    </DateRow>
                    <div className="h-[56px]"></div>
                </DesktopContainer>
                <MobileContainer>
                    <MInputContainer>
                        <MInput onClick={() => setVisible('fromDate')}>
                            <span>{fromDate.format("DD/MM/YYYY") || T("From")}</span>
                            <DateIcon />
                        </MInput>
                        <ContainerRow style={{ width: 15 }} />
                        <MInput onClick={() => setVisible('toDate')}>
                            <span>{toDate.format("DD/MM/YYYY") || T("To")}</span>
                            <DateIcon />
                        </MInput>
                    </MInputContainer>
                    {
                        visible ? (
                            <MModal>
                                {/* <MModalHead>
                                    <Back2Icon onClick={() => setVisible("")} />
                                    <Close2Icon onClick={() => setVisible("")} />
                                </MModalHead> */}
                                <div  onClick={() => setVisible("")}  className="relative float-right right-6 top-3 w-[32px] bg-[#fff] h-[32px] rounded-2xl flex justify-center items-center">
                                    <Close3Icon/>
                                </div>
                                <DateSelect
                                    minDate={fromDate} maxDate={toDate} mode={visible === 'fromDate' ? 'min' : 'max'}
                                    value={visible === 'fromDate' ? fromDate : toDate}
                                    onSelect={(event) => {
                                        onChange(event, visible);
                                        setVisible("")
                                    }} />
                            </MModal>
                        ) : null
                    }

                </MobileContainer>

                <ContainerCenter style={{ position: "relative", top: "calc(100% - 152px)", gap: 8 }}>
                    <FormButton2 className="black2" style={{ minWidth: 170 }} onClick={props.onCancel}>{T("Cancel")}</FormButton2>
                    <ContainerRow style={{ width: 12 }} />
                    <FormButton style={{ minWidth: 170 }} onClick={onSubmit}>{T("Confirm")}</FormButton>
                </ContainerCenter>
            </DatePickerContainerContent>
        </DatePickerContainer>
    )
}